import { useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { useForm } from '../../hooks/useForm.js';
import { resolveBlockProps } from '../../hooks/useJSONRef/resolveBlockProps.js';
import { identity } from '../../utils/fp/identity.js';
import { zip } from '../../utils/fp/zip.js';
import { filterBlocks } from './filterBlocks.js';
export const useFiltrationForm = (initialFormState, { block, page, normalize = identity }) => {
    const blocks = block?.blocks || [];
    const [filtrationState, { field, reset, update }] = useForm(initialFormState);
    const blocksWithProps = useMemo(() => zip(blocks, blocks.map((b) => resolveBlockProps(b.content, page?.fallback))), [blocks, page?.fallback]);
    const blocksToRender = filtrationState === initialFormState
        ? blocks
        : filterBlocks(blocksWithProps, filtrationState)(normalize);
    return [filtrationState, { blocksToRender, blocksWithProps }, { field, reset, update }];
};
//# sourceMappingURL=useFiltrationForm.js.map